import usePonyfill from '../providers/Ponyfill/usePonyfill';

export default usePonyfill;
